import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.expenses')
  .factory('ExpensesApi', ExpensesApi);

function ExpensesApi(): BringozApi {
  return {
    base: `/expenses`,
    infiniteScroll: {
      address: `/expenses`,
      cmd: 'GET'
    },
    actions: {
      getOne: {
        address: '{id}',
        cmd: 'GET',
        updateable: true
      },
      createExpense: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      updateExpense: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      approveExpenses: {
        address: 'approve',
        cmd: 'POST',
        updateable: true
      },
      declineExpenses: {
        address: 'decline',
        cmd: 'POST',
        updateable: true
      },
      deleteExpenses: {
        address: '',
        cmd: 'DELETE',
        updateable: true
      },
      exportExpenses: {
        address: 'export',
        cmd: 'POST',
        updateable: true
      },
      getExpenseTimeLine: {
        address: '{id}/timeline',
        cmd: 'GET',
        updateable: true
      },
    }
  }
}
